module.exports = __webpack_public_path__ + "img/16.95717105.jpg";